import { render, staticRenderFns } from "./Statements-menu.vue?vue&type=template&id=52091df6"
import script from "./Statements-menu.vue?vue&type=script&lang=js"
export * from "./Statements-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports